export const FUNCTION_TYPE_LABEL = "$func_type";
export const FUNCTION_TABLE_NAME = "function_table"; // table name for exporting table of functions of wasm module
